import {defineStyleConfig} from '@chakra-ui/react'

const PaddingBlock = defineStyleConfig({
    baseStyle: {
        w: '100%',
    },
    variants: {
        black: {
            backgroundColor: 'background.dark',
        },
        white: {
            backgroundColor: 'background.default',
        },
        grey: {
            backgroundColor: 'background.light',
        },
    },
    sizes: {
        base: {
            pb: {base: 'xsmall.base', sm: 'xsmall.sm', md: 'xsmall.md', lg: 'xsmall.lg'},
        },
        sm: {
            pb: {base: 'small.base', sm: 'small.sm', md: 'small.md', lg: 'small.lg'},
        },
        md: {
            pb: {base: 'medium.base', sm: 'medium.sm', md: 'medium.md', lg: 'medium.lg'},
        },
        lg: {
            pb: {base: 'large.base', sm: 'large.sm', md: 'large.md', lg: 'large.lg'},
        },
        xl: {
            pb: {base: 'xlarge.base', sm: 'xlarge.sm', md: 'xlarge.md', lg: 'xlarge.lg'},
        },
    },
    defaultProps: {
        size: 'base',
    },
})

export default PaddingBlock
